module.exports = __webpack_public_path__ + "efded53edf02b8c07ae358120e40760c.svg";